import styles from './SectionHeader.module.css'

export default function SectionHeader({ label, title, desc, center = false }) {
  return (
    <header className={`${styles.header} ${center ? styles.center : ''}`}>
      {label && <p className="section-label">{label}</p>}
      <h2 className="section-title">{title}</h2>
      {desc && <p className="section-desc">{desc}</p>}
    </header>
  )
}
